const exome = {
    title: "Exome / Targeted Sequencing Documentation",

    fields: [
        {
            title: "Project Name",

            description:
                "Provide a meaningful and unique name for your sequencing project. This name will be used to identify the analysis throughout the platform.",

            examples: [
                "Breast_Cancer_Exome",
                "Familial_WES_Study",
                "Patient_001_Exome",
            ],

            notes: [
                "Choose a descriptive project name.",
                "Avoid using special characters where possible.",
                "The project name will appear in your dashboard and reports.",
            ],
        },

        {
            title: "Number of Samples",

            description:
                "Enter the total number of samples included in this analysis. Credits will be calculated automatically based on the number of samples.",

            examples: [
                "1",
                "5",
                "20",
            ],

            notes: [
                "Must be greater than zero.",
                "Ensure the number matches the uploaded samples.",
            ],
        },

        {
            title: "Short Notes",

            description:
                "Provide any additional information that may help the bioinformatics team understand your experiment or special analysis requirements.",

            examples: [
                "Tumor vs Normal comparison.",
                "Samples sequenced using Illumina NovaSeq.",
            ],

            notes: [
                "Optional field.",
                "Mention any special instructions if required.",
            ],
        },

        {
            title: "Raw Data Source",

            description:
                "Specify how your sequencing data will be provided for analysis.",

            examples: [
                "Online",
                "Offline",
            ],

            notes: [
                "For Online, provide the download link to your sequencing files.",
                "Username and password can be provided if the link is protected.",
                "If Offline is selected, our team will contact you regarding the data transfer process.",
            ],
        },

        {
            title: "Organism",

            description:
                "Select the reference genome that matches your sequencing data. You must choose one of the available organisms before proceeding.",

            examples: [
                "Homo sapiens (hg19)",
                "Homo sapiens (hg38)",
            ],

            notes: [
                "Only the available reference genomes can be selected.",
                "Choosing the correct organism ensures accurate alignment and downstream analysis.",
            ],
        },

        {
            title: "Alignment Tool",

            description:
                "Select the alignment tool used to map sequencing reads to the selected reference genome.",

            examples: [
                "BWA",
                "Bowtie2",
            ],

            notes: [
                "The selected tool affects alignment speed and mapping accuracy.",
                "Choose the aligner appropriate for your sequencing workflow.",
            ],
        },

        {
            title: "Metadata Builder",

            description:
                "Provide a unique Sample ID for each sample included in the analysis. These identifiers will be used throughout the workflow and in the final reports.",

            examples: [
                "Sample_001",
                "Patient_A01",
                "Control_01",
            ],

            notes: [
                "At least one Sample ID is required.",
                "Each Sample ID must be unique.",
                "Click 'Add Sample' to include additional samples.",
                "Click 'Save Metadata' once all Sample IDs have been entered.",
                "Use 'Modify Metadata' to edit the metadata after saving.",
            ],
        },

        {
            title: "Target BED File Link",

            description:
                "Provide the download link to the BED file containing the genomic target regions for targeted sequencing analysis.",

            examples: [
                "https://example.com/panel.bed",
            ],

            notes: [
                "Optional field.",
                "Provide this only if targeted regions are required for analysis.",
                "Ensure the link is accessible.",
            ],
        },

        {
            title: "Raw Data QC Parameters",

            description:
                "Configure the quality control parameters used to filter sequencing reads before downstream analysis.",

            sections: [
                {
                    title: "Phred Quality Score",
                    description:
                        "Defines the minimum acceptable base quality score during quality filtering.",
                    notes: [
                        "Allowed range: 10–40.",
                        "Default value: 30.",
                        "Higher values provide stricter quality filtering.",
                    ],
                },
                {
                    title: "Minimum Read Length Required",
                    description:
                        "Specifies the minimum read length that must remain after trimming.",
                    notes: [
                        "Allowed range: 50–120 bases.",
                        "Default value: 75 bases.",
                        "Reads shorter than the specified length will be discarded.",
                    ],
                },
            ],
        }
    ],
};

export default exome;